import './App.css';
import { useState, useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PopularServices } from './components/PopularServices';
import { HowItWorks } from './components/HowItWorks';
import { ComplianceSection } from './components/ComplianceSection';
import { Footer } from './components/Footer';
import { ContactModal } from './components/ContactModal';
import { Chatbot } from './components/Chatbot';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const [hasShownScrollPopup, setHasShownScrollPopup] = useState(false);

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
    setHasShownScrollPopup(true); // Mark as shown to prevent auto-popup
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedService("");
  };

  const handleChatbotSubmit = (data) => {
    console.log("Chatbot form submitted:", data);
    // You can also open the modal with the data if needed
    // setSelectedService(data.service);
    // setIsModalOpen(true);
  };

  // Auto-open modal on scroll midway
  useEffect(() => {
    const handleScroll = () => {
      if (hasShownScrollPopup || isModalOpen) return;

      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Calculate if user has scrolled to midway (50%)
      const scrollPercentage = (scrollPosition / (documentHeight - windowHeight)) * 100;
      
      if (scrollPercentage >= 50) {
        setIsModalOpen(true);
        setHasShownScrollPopup(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasShownScrollPopup, isModalOpen]);

  const handleContactClick = () => {
    setIsModalOpen(true);
    setHasShownScrollPopup(true); // Mark as shown to prevent auto-popup
  };

  return (
    <div className="App">
      <Header onServiceClick={handleServiceClick} onContactClick={handleContactClick} />
      <Hero onServiceClick={handleServiceClick} />
      <PopularServices onServiceClick={handleServiceClick} />
      <HowItWorks />
      <ComplianceSection onContactClick={handleContactClick} />
      <Footer onServiceClick={handleServiceClick} onContactClick={handleContactClick} />
      <ContactModal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal}
        selectedService={selectedService}
      />
      <Chatbot onFormSubmit={handleChatbotSubmit} />
    </div>
  );
}

export default App;
